export const MAINNET_ID = 1;
export const RINKEBY_ID = 4;
export const CONTRACT_ADDRESSES = {
  [MAINNET_ID]: "0xbc0E164eE423B7800e355b012c06446e28b1a29d",
};
